import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { SOFAR_PRIVACY_POLICY_URL } from 'app/shared/utils/siteUrls';
import { Box, Typography } from 'app/shared/components/atoms';
import { NavigationLink as Link } from 'app/shared/components/atoms';
import { MappingsProps } from 'app/fan/components/templates/EventPage/components/EventCharacteristicsList/utils';
import { ReactComponent as AlertTriangle } from 'icons/alert-triangle.svg';
import { ReactComponent as Camera } from 'icons/camera.svg';
import { ReactComponent as Clock } from 'icons/clock.svg';
import { ReactComponent as Indoors } from 'icons/lamp.svg';
import { ReactComponent as Outdoors } from 'icons/outdoors.svg';

export function useOtherMappings({ formatMessage }: MappingsProps) {
  const { colors } = useCurrentTheme();
  const intlPrefix = 'event.eventCharacteristicsList.other';

  return {
    outdoors: {
      id: 'environment',
      title: formatMessage({ id: `${intlPrefix}.outdoors` }),
      icon: Outdoors,
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage({ id: `${intlPrefix}.outdoors.details` })}
        </Typography>
      ),
    },
    indoors: {
      id: 'environment',
      title: formatMessage({ id: `${intlPrefix}.indoors` }),
      icon: Indoors,
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage({ id: `${intlPrefix}.indoors.details` })}
        </Typography>
      ),
    },
    afternoonShow: {
      id: 'afternoon',
      title: formatMessage({ id: `${intlPrefix}.afternoonShow` }),
      icon: Clock,
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage({ id: `${intlPrefix}.afternoonShow.details` })}
        </Typography>
      ),
    },
    filmedShow: {
      id: 'filmed',
      title: formatMessage({ id: `${intlPrefix}.filmedShow` }),
      icon: Camera,
      details: (
        <Box>
          <Typography
            color={colors.primary.white.base}
            as="span"
            display="inline"
          >
            {formatMessage({ id: `${intlPrefix}.filmedShow.details` })}
          </Typography>
          <Link href={SOFAR_PRIVACY_POLICY_URL} openInNewTab variant="primary">
            {formatMessage({ id: `${intlPrefix}.filmedShow.privacyPolicy` })}
          </Link>
          <Typography
            color={colors.primary.white.base}
            as="span"
            display="inline"
          >
            {formatMessage({ id: `${intlPrefix}.filmedShow.andOur` })}
          </Typography>{' '}
          <Link
            href="https://www.sofarsounds.com/terms_and_conditions"
            openInNewTab
            variant="primary"
          >
            {formatMessage({ id: `${intlPrefix}.filmedShow.termsOfUse` })}
          </Link>
          .
        </Box>
      ),
    },
    firstComeFirstServed: {
      id: 'first_come_first_served',
      title: formatMessage({ id: `${intlPrefix}.firstComeFirstServed` }),
      icon: AlertTriangle,
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage({ id: `${intlPrefix}.firstComeFirstServed.details` })}
        </Typography>
      ),
    },
  };
}
